// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import VueTheMask from 'vue-the-mask'

// Leaflet
import 'leaflet/dist/leaflet.css'

import Vue from 'vue'

// Components
import './components'

// Plugins
import './plugins'

// Sync router with store
import { sync } from 'vuex-router-sync'

// Application imports
import App from './App'
import router from '@/router'
import store from '@/store'
import RouteSecurity from './guard/route-security'
import HookUser from './guard/user-hook'

import vuetify from './plugins/vuetify'

// Sentry
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
if (document.location.hostname !== 'localhost' && process.env.VUE_APP_SENTRY_DSN && process.env.VUE_APP_SENTRY_DSN !== '') {
  console.log('Sentry dsn : ', process.env.VUE_APP_SENTRY_DSN)
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN + '',
    integrations: [new Integrations.Vue({ Vue, attachProps: true })]
  })
}

// Sync store with router
sync(store, router)

// Adding guard security of route
RouteSecurity(router, store)
HookUser(store)

// Vue mask
Vue.use(VueTheMask)

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  router,
  store,
  vuetify,
  mounted: () => {
    document.getElementById('mainLoader').style.display = 'none'
  },
  render: h => h(App)
}).$mount('#app')
